import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    routes: []
  },
  getters: {
    navs: (state) => {
      return state.routes
    }
  },
  mutations: {
    setRoutes (state, payload) {
      state.routes = payload
    },
    setUser (state, payload) {
      state.user = payload
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js